<template><svg xmlns="http://www.w3.org/2000/svg" width="32.005" height="32.414" viewBox="0 0 32.005 32.414">
  <g id="Group" transform="translate(-0.628 -0.998)">
    <rect id="Rectangle_Copy_3" data-name="Rectangle Copy 3" width="41.262" height="4" rx="2" transform="translate(3.457 0.998) rotate(45)" fill="#a5a19d" />
    <rect id="Rectangle_Copy_4" data-name="Rectangle Copy 4" width="41.262" height="4" rx="2" transform="translate(0.628 30.583) rotate(-45)" fill="#a5a19d" />
  </g>
</svg>
</template>